import { Link } from "@arp/react-ndbx";
import React from "react";
import { pdf } from "../../../utilities/axios-utils";
import useSharedData from "../../../hooks/useSharedData";

const RecordOfAnswers = ({ children }) => {
  const { accessToken, handleEventChange } = useSharedData();

  const retrieveROA = async () => {
    handleEventChange({ name: "isPageLoading", value: true });
    const url = await pdf({
      accessToken,
      path: "/documents/roa",
      headers: { "Applicant-id": 1 },
    });
    handleEventChange({ name: "isPageLoading", value: false });
    if (url) {
      window.open(url, "_blank");
    }
    return false;
  };

  return (
    <Link href="javascript:;" onClick={retrieveROA}>
      {children}
    </Link>
  );
};

export default RecordOfAnswers;
